// extracted by mini-css-extract-plugin
export default {"box":"Page_box__8iONK"};